import { render } from "./DataSubmit.vue?vue&type=template&id=6f8ad178&scoped=true"
import script from "./DataSubmit.vue?vue&type=script&lang=js"
export * from "./DataSubmit.vue?vue&type=script&lang=js"

import "./DataSubmit.vue?vue&type=style&index=0&id=6f8ad178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8ad178"]])

export default __exports__